/**
 * Silly cartoon-style names for TestData fake identities (mentors/freshlings).
 * Kept separate so TestData.js stays readable.
 */
export const CARTOON_NAME_POOL = [
  'Bingle McSwap',
  'Princess Fuzzbucket',
  'Dr. Glorp Noodle',
  "Snoutly O'Peel",
  'Wibbleton Crumbs',
  'Captain Sidequest',
  'Professor Mumblemore',
  'Sir Reginald Squeak',
  'Baron Von Toaster',
  'Lady Horkington',
  'Count Gleep',
  'Duke Flapjack',
  'Marquis of Wet Socks',
  'Earl Dribble',
  'Viscount Crunchwrap',
  'Baroness Wobble',
  'Grandpa Gristle',
  'Nana Noodlearm',
  'Uncle Beeforoni',
  'Auntie Spamwiggle',
  'Cousin Floop',
  'Nephew Dangle',
  'Sneezy McHonk',
  'Wheezy Bagpipes',
  'Stuffy Puffcheeks',
  'Blinky Wrongway',
  'Pinky Toebiter',
  'Brainy McNoThoughts',
  'Spanky Biscuit',
  'Twisty Pretzelbrain',
  'Gargle Blaster',
  'Fizzle Pop',
  'Snork Whistletoes',
  'Plorp Master',
  'Zorp Minor',
  'Xanthar the Moist',
  'Yolanda Yawnface',
  'Quentin Quibble',
  'Ursula Underbite',
  'Ignatz Itchy',
  'Oswald Oops',
  'Petunia Ploop',
  'Horatio Hork',
  'Gertrude Gargle',
  'Mortimer Mumble',
  'Eustace Earwax',
  'Prudence Prune',
  'Cedric Crust',
  'Agatha Aglet',
  'Barnaby Booger',
  'Cornelius Cornchip',
  'Dorothea Droop',
  'Edgar Eggyolk',
  'Fiona Fuzznugget',
  'Gilbert Grist',
  'Harriet Hiccup',
  'Ivan Ittybitty',
  'Jasper Jorts',
  'Kiki Kerfuffle',
  'Lionel Lint',
  'Mabel Mucus',
  'Norbert Nub',
  'Opal Oobleck',
  'Percy Pustule',
  'Queenie Quackers',
  'Rufus Rumblegut',
  'Stella Stinkbug',
  'Trevor Tater',
  'Uma Unicycle',
  'Vera Velveeta',
  'Wallace Wart',
  'Xerxes Xylophone',
  'Yvette Yawn',
  'Zeke Zit',
  'Boppo the Clownfish',
  'Zippy Longflaps',
  'Goober McStretch',
  'Snickerdoodle Jones',
  'Waffle Ironstein',
  'Pickle Rickrack',
  'Chimichanga Chomp',
  'Burrito Bandito',
  'Taco Tuesday Jr',
  'Nacho Libre Libre',
  'Salsa Verde Vance',
  'Guacamole Gary',
  'Queso Queen',
  'Enchilada Ed',
  'Fajita Frank',
  'Pretzel Pete',
  'Bagel Beth',
  'Muffin Top Mike',
  'Croissant Carl',
  'Scone Sloane',
  'Biscuit Brenda',
  'Gravy Greta',
  'Butter Bob',
  'Margarine Marge',
  'Mayonnaise Mason',
  'Ketchup Kelly',
  'Mustard Maude',
  'Relish Rex',
  'Pickle Paula',
  'Olive Oyl Jr',
  'Anchovy Andy',
  'Sardine Steve',
  'Tuna Terry',
  'Salmon Sally',
  'Trout Todd',
  'Bass Boss',
  'Carp Carlotta',
  'Minnow Minnie',
  'Guppy Gus',
  'Blobfish Betty',
  'Anglerfish Angie',
  'Jellyfish Jake',
  'Starfish Stu',
  'Seahorse Hank',
  'Clammy Sammy',
  'Mussel Muscle',
  'Oyster Ozzy',
  'Scallop Scott',
  'Shrimpy Tim',
  'Lobster Larry',
  'Crabby Patty',
  'Squidward Jr',
  'Octopus Otto',
  'Cuttlefish Cuthbert',
  'Nautilus Nate',
  'Barnacle Barry',
  'Plankton Plank',
  'Algae Al',
  'Kelp Karen',
  'Seaweed Steve',
  'Coral Corey',
  'Reef Rhonda',
  'Tide Pool Tina',
  'Briny Brian',
  'Salty Sue',
  'Foamy Phil',
  'Splashy Spencer',
  'Drippy Denise',
  'Soggy Sam',
  'Moldy Mildred',
  'Fungus Fenton',
  'Mildew Miles',
  'Spore Sophia',
  'Yeast Yolanda',
  'Bacteria Barry',
  'Germaine Germ',
  'Virus Vinnie',
  'Prion Pat',
  'Amoeba Amy',
  'Paramecium Pam',
  'Mitochondria Mitch',
  'Ribosome Rita',
  'Lysosome Lisa',
  'Golgi Greg',
  'Endoplasm Eddie',
  'Nucleus Nick',
  'Membrane Meme',
  'Cytoplasm Cy',
  'Vacuole Val',
  'Chloroplast Chloe',
  'Photosynth Phil',
  'Stomata Stan',
  'Xylem Xena',
  'Phloem Floyd',
  'Root Rot Randy',
  'Compost Connie',
  'Mulch Merv',
  'Peat Pete',
  'Loam Lorna',
  'Clay Clem',
  'Silt Silas',
  'Sand Sandy',
  'Gravel Gary',
  'Pebble Penelope',
  'Rocky Rochelle',
  'Boulder Bo',
  'Cliff Cliff',
  'Ravine Raven',
  'Gulch Gus',
  'Canyon Candy',
  'Mesa Mesa',
  'Butte Butch',
  'Plateau Patrice',
  'Fjord Fjord',
  'Glacier Gladys',
  'Tundra Ted',
  'Taiga Tanya',
  'Steppe Steph',
  'Prairie Perry',
  'Savanna Savvy',
  'Marsh Marsha',
  'Swamp Swanson',
  'Bog Bogdan',
  'Fen Fenwick',
  'Moor Moore',
  'Heath Heather',
  'Dale Dale',
  'Vale Valerie',
  'Glen Glenn',
  'Dell Della',
  'Knoll Nolan',
  'Hill Hillary',
  'Mound Mounds',
  'Dune June',
  'Drift Drifty',
  'Sleet Sleet',
  'Slush Slushy',
  'Hail Hale',
  'Graupel Gretel',
  'Sleet Pete Repeat',
  'Thunder Thad',
  'Lightning Lottie',
  'Zap Zippy',
  'Buzz Buzzkill',
  'Hum Humdrum',
  'Whir Whirly',
  'Click Clack',
  'Clunk Clunker',
  'Thunk Thunk',
  'Bonk Bonkers',
  'Boing Boingo',
  'Sproing Sprout',
  'Splat Splatterson',
  'Sploot Splooter',
  'Skoot Skooter',
  'Scoot McToot',
  'Toot Tooterson',
  'Honk Honkerson',
  'Beep Beeperson',
  'Bleep Bleeper',
  'Bloop Blooper',
  'Blarp Blarpson',
  'Fwomp Fwompy',
  'Thwomp Thwompson',
  'Kerplunk Karl',
  'Kaboom Kiki',
  'Wallop Wally',
  'Thwack Thackery',
  'Whack Wendell',
  'Smack Smacky',
  'Whomp Whompy',
  'Flomp Flompy',
  'Glomp Glenda',
  'Chomp Chester',
  'Stomp Stevie',
  'Rompy Rompus',
  'Wompy Wampus',
  'Zompy Zombie',
  'Yomp Yancy',
  'Pomp Pompadour',
  'Frump Frumple',
  'Grump Grumpleton',
  'Plump Plimpton',
  'Stump Stumpy',
  'Bump Bumperton',
  'Hump Humphrey',
  'Jump Jupiter',
  'Lump Lumpkin',
  'Pumpkin Pete',
  'Gourd Geoff',
  'Squash Squashy',
  'Gourd Lord',
  'Melon Mel',
  'Cantaloupe Canty',
  'Honeydew Huey',
  'Watermelon Walter',
  'Cucumber Cuthbert Jr',
  'Zucchini Zeke',
  'Eggplant Edna',
  'Turnip Turner',
  'Radish Rad',
  'Beet Beatrice',
  'Carrot Carrotte',
  'Parsnip Parsley',
  'Rutabaga Ruby',
  'Kohlrabi Kyle',
  'Arugula Argus',
  'Kale Kaleb',
  'Chard Charlotte',
  'Collard Collin',
  'Mustard Greens Gregg',
  'Spinach Spinny',
  'Lettuce Letty',
  'Cabbage Cabbie',
  'Broccoli Brock',
  'Cauliflower Cauli',
  'Brussels Sprout Bruce',
  'Asparagus Gus Gus',
  'Artichoke Archie',
  'Leek Lee',
  'Onion Onionio',
  'Shallot Shal',
  'Garlic Gareth',
  'Chive Chives',
  'Scallion Scally',
  'Fennel Fen',
  'Dill Pickle Dill',
  'Cilantro Cindy',
  'Basil Basilisk',
  'Oregano Oreo',
  'Thyme Timmy',
  'Rosemary Rose',
  'Sage Serge',
  'Minty Minerva',
  'Paprika Pepper',
  'Cumin Human',
  'Turmeric Turmerica',
  'Cardamom Cardi',
  'Nutmeg Nutmeggy',
  'Clove Clovis',
  'Allspice Alice',
  'Star Anise Anise',
  'Vanilla Van',
  'Cinnamon Synnamon',
  'Ginger Ginny',
  'Wasabi Wally',
  'Horseradish Horace',
  'Sriracha Sierra',
  'Tabasco Tabby',
  'Cholula Cholly',
  'Tapatio Tapi',
  'Valentina Val',
  "Frank's RedHot Frank",
  'Buffalo Bill Buffer',
  'Ranch Randy',
  'Blue Cheese Blu',
  'Caesar Seizure',
  'Thousand Island Ivan',
  'Italian Vinny',
  'French Francine',
  'Russian Rus',
  'Honey Mustard Honey',
  'BBQ Barb',
  'Teriyaki Terryaki',
  'Sweet Chili Sweetie',
  'Plum Sauce Plummy',
  'Duck Sauce Ducky',
  'Soy Sauce Soyboy',
  'Fish Sauce Phish',
  'Oyster Sauce Oystie',
  'Hoisin Hoison',
  'Miso Missy',
  'Tahini Tina',
  'Pesto Pesto Pete',
  'Alfredo Fredo',
  'Marinara Mara',
  'Bolognese Bolly',
  'Carbonara Carla',
  'Puttanesca Putty',
  'Arrabbiata Arra',
  'Amatriciana Amos',
  'Vodka Sauce Volga',
  'Pink Sauce Pinky',
  'White Sauce Whit',
  'Green Sauce Greenie',
  'Brown Gravy Brownie',
  'Country Gravy Cletus',
  'Sausage Gravy Sassy',
  'Red Eye Gravy Red',
  'Chocolate Gravy Choco',
  'Biscuits Bobbins',
  'Gravy Train Tracy',
  'Sauce Boss Ross',
  'Dip Master Dipper',
  'Chip Champion Chip',
  'Snack Attack Snacky',
  'Munch Man Munch',
  'Crunch Lord Crunchy',
  'Nibble Nob',
  'Gobble Gob',
  'Scarf Scarfy',
  'Wolf Down Wolfgang',
  'Hoover Hooverton',
  'Vacuum Vance',
  'Suck It Up Chuck',
  'Inhale Ingrid',
  'Devour Devin',
  'Annihilate Annie',
  'Obliterate Ollie',
  'Demolish Demi',
  'Destroy Dexter',
  'Ruin Rupert',
  'Wreck Rex',
  'Smash Smashley',
  'Bash Basha',
  'Crash Crasher',
  'Dash Dashiell',
  'Flash Flashy',
  'Trash Trish',
  'Stash Stashton',
  'Hash Hashtag',
  'Mash Masha',
  'Gash Gashley',
  'Lash Lashonda',
  'Clash Clayton',
  'Brash Brashford',
  'Swash Swashbuckler',
  'Squash Court Courtney',
  'Wash Washington',
  'Wish Wishy',
  'Fish Fishy',
  'Dish Dishy',
  'Swish Swisher',
  'Squish Squishy',
  'Polish Polly',
  'Relish Relisher',
  'Furnish Furnace',
  'Tarnish Tarn',
  'Vanish Vanna',
  'Banish Banjo',
  'Danish Danny',
  'Spanish Span',
  'Ticklish Ticks',
  'Childish Childo',
  'Foolish Foolbert',
  'Selfish Selfie',
  'Knish Knishy',
  'Delish Delilah',
];
